module.exports = __webpack_public_path__ + "img/down_arrow_icon.940f2173.svg";